import React, {memo} from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {
    IMG_PRODUCTS_PUBLIC_URL_SERVER,
    PUBLIC_URL_SERVER
} from "../../../../apis";
import imgPlayS from "../../../../images/base-image-product.jpg";
import {Row, Col} from "react-bootstrap";

const CardItemModalMyFoodPacks = (props) => {
    const {data} = props;
    const {food_pack} = data;


    const handleOpenFoodPackDetails = () => {
        console.log("cliecked");
        window.open("/my-food-pack/" + food_pack.id, "_self");
    }


    return (
        <div className={'item-box-shopping-card'}>
            <div className={'fx-item-box-shopping-card'} onClick={handleOpenFoodPackDetails} style={{cursor: "pointer"}}>
                <div className={'img-box-shopping-card'}>
                    <LazyLoadImage
                        width={64}
                        height={64}
                        alt={food_pack.name}
                        src={PUBLIC_URL_SERVER + IMG_PRODUCTS_PUBLIC_URL_SERVER + food_pack.image}
                        placeholderSrc={imgPlayS}
                    />
                </div>
                <div className={'base-data-box-shopping-card'}>
                    <Row>
                        <Col xs={12}>
                            <div className={'title-box-shopping-card'}>
                                <h6 className={'m-0'}>{food_pack.name ? food_pack.name : 'نام محصول'}</h6>
                                <p>{food_pack.first_desc ? food_pack.first_desc : 'توضیحات'}</p>
                                <p>{food_pack.second_desc ? food_pack.second_desc : 'توضیحات'}</p>
                            </div>
                        </Col>
                        
                    </Row>
                    
                </div>
            </div>
        </div>
    );
};

export default memo(CardItemModalMyFoodPacks);
